export default __webpack_public_path__ + "static/media/dollar.383ef5e5.svg";